export default {
  getCollection: (state) => state.collection,
  getCollections: (state) => state.collections,
  getCollectionsMap: (state) => {
    return (state.collections || []).reduce((prev, next) => {
      const { id } = next;
      prev[id] = next;
      return prev;
    }, {});
  },
};
